import { mapRoutesFromMd } from '/app/utils/route';

const pages = import.meta.glob('./content/*.md', { eager: true });

export const children = mapRoutesFromMd(pages, { prefix: 'faqs' });
